import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Dropdown, Modal } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import Img from "shared/assets/images/svg/image_placeholder_nav.svg";
import { useSetRecoilState } from "recoil";
import { LanguageAtom, useLocalize } from "shared/helpers/language";
import { useAuthContext } from "shared/context/auth-context";
import useModal from "shared/hooks/useModel";
import CloseIcon from 'shared/assets/images/svg/close_form.svg'
import Logo from 'shared/assets/images/png/logo.png'
import { useTranslation } from "react-i18next";
export function AdminNavbar() {
  const [isSigningOut, openSignOutDialog, closeSignOutDialog] = useModal(false);


  // return (
 
  // );

}

export function GuestNavbar() {
  const{t}=useTranslation();
  const { currentLanguage } = useLocalize();
  const setLangCode = useSetRecoilState(LanguageAtom);

  return (
    <div className="full-navbar">
      <Navbar className="navbar" bg="light" expand="lg" fixed="top">
        <Container>
        <Navbar.Brand className="logo" href="#"><img src={Logo } alt="logo"/></Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="me-auto my-2 my-lg-0" navbarScroll>
              <NavLink to="/" className="nav-link">
                {t('homepage.mainTitle')}
              </NavLink>

              {currentLanguage.code === "en" ? (
                <span onClick={() => setLangCode("ar")} className="nav-link">
                  عربي
                </span>
              ) : (
                <span onClick={() => setLangCode("en")} className="nav-link">
                  English
                </span>
              )}
            </Nav>
            <div className="d-flex">
              <Link to="/login" className="btn-border-blue">
              {t('homepage.signIn')}              </Link>
              <Link to="/signup/customer" className="btn-blue">
              {t('homepage.signUp')}              </Link>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export function CustomerNavbar() {
  const{t}=useTranslation();
  const [{ user }] = useAuthContext();
  const [isSigningOut, openSignOutDialog, closeSignOutDialog] = useModal(false);
  const handleCollapse = (e) => {
    var btn = document.getElementById("navbarScroll");
    btn.classList.remove("show");
   
  };


  return (
    <div className="full-navbar">
      <Navbar className="navbar" bg="light" expand="lg" fixed="top" id="navbarNav">
        <Container>
          <Navbar.Brand className="logo" href="#"><img src={Logo } alt="logo"/></Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="me-auto my-2 my-lg-0" navbarScroll>
              <NavLink to="/" className="nav-link" onClick={handleCollapse}>
                Home
              </NavLink>
              <NavLink to="/my-booking" className="nav-link" onClick={handleCollapse}>
                  My Booking
              </NavLink>
              <NavLink to="/my-balance" className="nav-link" onClick={handleCollapse}>
                My Balance
              </NavLink>
              {/* <NavLink to="/Completed" className="nav-link">
                Completed
              </NavLink>
              <NavLink to="/reports" className="nav-link">
                Reports
              </NavLink> */}
            </Nav>
            <div className="d-flex">
              <Dropdown className="profileMenu">
                <Dropdown.Toggle id="dropdown-basic">
                  <img src={Img} alt="Img" />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {/* <div className="info">
                    <h2>{localize(user.name)}</h2>
                    <p>{user.email}</p>
                  </div>
                  <hr className="hr" /> */}
                  <Dropdown.Item>
                    <Link className="dropdown-item" to="/settings" onClick={handleCollapse}>
                      My Settings
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={openSignOutDialog}>  {t('homepage.signOut')}</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Navbar.Collapse>
          <SignOutDialog show={isSigningOut} hide={closeSignOutDialog} />
        </Container>
      </Navbar>
    </div>
  );
}

export function SignOutDialog({ show, hide }) {
  const{t}=useTranslation();
  const [, dispatch] = useAuthContext();
  return (


    <Modal size="md" centered show={show} className="all-modal Admin-modal">
      <Modal.Body>
        <div className="header">
            <h1>{t('homepage.msgHead')}</h1>
            <img src={CloseIcon} alt="CloseIcon" onClick={hide}/>
        
        </div>
        <hr className="hr" />
        <p className="info">{t('homepage.outMsg')}</p>

        <button className="btn-blue w-100" onClick={() => dispatch({ type: "logout" })}> {t('homepage.signOut')}</button>

      </Modal.Body>
    </Modal>
  );
}


